// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Helpers
import { StyledCircle, StyledItem, StyledLabel, StyledValue, StyledWrapper } from './ProfileInfoStyles';
import { IAdminProfile } from '@/models/admins.model';

interface IProfileInfo {
  profileData: IAdminProfile | null;
}

const ProfileInfo = ({ profileData }: IProfileInfo) => {
  const { t } = useTranslation(['profile']);

  return (
    <StyledWrapper>
      <StyledItem>
        <StyledLabel>{t('profile_first_name')}</StyledLabel>
        <StyledValue>{profileData?.firstName}</StyledValue>
      </StyledItem>
      <StyledItem>
        <StyledLabel>{t('profile_last_name')}</StyledLabel>
        <StyledValue>{profileData?.lastName}</StyledValue>
      </StyledItem>
      <StyledItem>
        <StyledLabel>{t('profile_email')}</StyledLabel>
        <StyledValue>{profileData?.email}</StyledValue>
      </StyledItem>
      <StyledItem>
        <StyledLabel>{t('profile_id')}</StyledLabel>
        <StyledValue>{profileData?.id}</StyledValue>
      </StyledItem>
      <StyledItem>
        <StyledLabel>{t('profile_password')}</StyledLabel>
        <StyledValue>
          <StyledCircle />
          <StyledCircle />
          <StyledCircle />
          <StyledCircle />
          <StyledCircle />
        </StyledValue>
      </StyledItem>
    </StyledWrapper>
  );
};

export default ProfileInfo;
